module.exports = __webpack_public_path__ + "img/head_logo.79412119.png";